export const MAP_PAGE = 'map_page_module'
export const AUTH_MODULE = 'auth_module'
export const LANDING_MODULE = 'landing_module'
export const SETTINGS_MODULE = 'settings_module'
export const USER_STATISTICS_MODULE = 'user_statistics_module'
export const MANAGER_MAP_MODULE = 'manager_map_module'
export const DRIVER_TABLE_MODULE = 'driver_table_module'
export const SNACKBAR_MODULE = 'snackbar_module'
